export function calcItemPriceWithTax(price: number, tax: number): any {
	return price * tax + price
}
